import { HelperText, Spacer } from "components/views/atoms/Atoms"
import React from "react"
import { SinglePathSVG } from "components/views/SVG"
import styled from "styled-components"
import { Text } from "@carrotfertility/carotene"

const StyledValidationMessage = styled.div`
  min-height: 1.5rem;
  margin-top: 2px;
  margin-bottom: 6px;
  margin-left: 2px;
`

const StyledX = styled(SinglePathSVG)`
  margin-top: 1px;
  flex: none;
`

const ValidationMessage = ({ helperText = "", errors, name }) => {
  const valid = errors ? !errors[name] : true
  const showHelperText = valid && helperText
  return (
    <StyledValidationMessage>
      {!valid && (
        <div className="dib flex items-center invalid-red">
          <StyledX icon="x10" />
          <Spacer width={0.25} />
          <HelperText color="invalid-red">{errors[name].message}</HelperText>
        </div>
      )}
      {showHelperText && (
        <Text as="p" sx={{ marginBottom: "16px" }} size="14px" color="black60">
          {helperText}
        </Text>
      )}
    </StyledValidationMessage>
  )
}

export { ValidationMessage }
